import { endImpersonation, getErrorMessage } from '@shared/api';
import { APP_PATH } from '@shared/config';
import { toast } from '@shared/ui/toast';

/**
 * 대행 배너의 "종료". 기존 서비스(`ImpersonateHook.end`)처럼 대행자 신원으로 돌아가 계정 관리(`/member`)로 간다.
 * 토큰 갱신 한 번 — 리프레시 쿠키가 대행자의 것이라 대행자 신원으로 돌아온다(be.md B-4).
 */
export function useEndImpersonation(): () => void {
  return () => {
    void endImpersonation({ to: APP_PATH.member }).then((outcome) => {
      if (outcome.result === 'unreachable') toast.error(getErrorMessage(outcome.error));
    });
  };
}
